import axios from "axios";
import { msGraphPost, msGraphPut } from "../graph.general"; // Assuming the first set of functions is in graphApiUtils.js

const GRAPH_BASE = "https://graph.microsoft.com/v1.0";

/**
 * Uploads a file directly to Microsoft Graph.
 * @param {Object} fileObj - The file object to upload.
 * @param {string} groupId - The group ID where the file is uploaded.
 * @param {string} folderId - The folder ID where the file is uploaded.
 * @returns {Promise<Object>} - The response from the Graph API.
 */
export async function uploadFileDirectly(fileObj, groupId, folderId) {
  console.log(fileObj);
  if (!fileObj || !fileObj.contentBytes) {
    throw new Error("Invalid file object");
  }

  const binaryData = atob(fileObj.contentBytes); // Decode base64 to binary
  const arrayBuffer = new ArrayBuffer(binaryData.length);
  const uint8Array = new Uint8Array(arrayBuffer);
  for (let i = 0; i < binaryData.length; i++) {
    uint8Array[i] = binaryData.charCodeAt(i);
  }

  const fileBlob = new Blob([uint8Array], { type: fileObj.contentType });

  const uploadPath = `/groups/${groupId}/drive/items/${folderId}:/${fileObj.name}:/content?@microsoft.graph.conflictBehavior=rename`;

  const headers = {
    "Content-Type": fileObj.contentType,
    "Content-Length": fileObj.size,
  };

  console.log("Uploading file to:", uploadPath);

  if (fileObj.size < 4 * 1024 * 1024) {
    // Upload small files directly
    return await msGraphPut(uploadPath, fileBlob, true, headers, 1);
  } else {
    // Upload large files using session
    const sessionPath = `/groups/${groupId}/drive/items/${folderId}:/${fileObj.name}:/createUploadSession?@microsoft.graph.conflictBehavior=rename`;
    const sessionResponse = await msGraphPost(sessionPath, null, true, {}, 1);

    console.log(sessionResponse);
    const uploadUrl = sessionResponse.uploadUrl;

    const chunkSize = 4 * 1024 * 1024; // 4MB
    const chunks = Math.ceil(fileObj.size / chunkSize);
    let start = 0;

    for (let i = 0; i < chunks; i++) {
      const end = Math.min(start + chunkSize, fileBlob.size);

      const chunk = fileBlob.slice(start, end);

      await axios.put(uploadUrl, chunk, {
        headers: {
          "Content-Range": `bytes ${start}-${end - 1}/${fileBlob.size}`,
        },
      });

      start = end;
    }
    return { success: true, data: sessionResponse };

  }
  // }
}

/**
 * Uploads a file directly to Microsoft Graph.
 * @param {Object} fileObj - The file object to upload.
 * @param {string} groupId - The group ID where the file is uploaded.
 * @param {string} folderId - The folder ID where the file is uploaded.
 * @returns {Promise<Object>} - The response from the Graph API.
 */
export async function uploadFileToRoot(fileObj, folderId) {
  console.log(fileObj);
  if (!fileObj || !fileObj.contentBytes) {
    throw new Error("Invalid file object");
  }

  const binaryData = atob(fileObj.contentBytes); // Decode base64 to binary
  const arrayBuffer = new ArrayBuffer(binaryData.length);
  const uint8Array = new Uint8Array(arrayBuffer);
  for (let i = 0; i < binaryData.length; i++) {
    uint8Array[i] = binaryData.charCodeAt(i);
  }

  const fileBlob = new Blob([uint8Array], { type: fileObj.contentType });

  const uploadPath = `/me/drive/items/${folderId}:/${fileObj.name}:/content?@microsoft.graph.conflictBehavior=rename`;

  const headers = {
    "Content-Type": fileObj.contentType,
    "Content-Length": fileObj.size,
  };

  console.log("Uploading file to:", uploadPath);

  if (fileObj.size < 4 * 1024 * 1024) {
    // Upload small files directly
    return await msGraphPut(uploadPath, fileBlob, true, headers, 1);
  } else {
    // Upload large files using session
    const sessionPath = `/me/drive/items/${folderId}:/${fileObj.name}:/createUploadSession?@microsoft.graph.conflictBehavior=rename`;
    const sessionResponse = await msGraphPost(sessionPath, null, true, {}, 1);
    const uploadUrl = sessionResponse.uploadUrl;

    const chunkSize = 5 * 1024 * 1024; // 5MB
    const chunks = Math.ceil(fileObj.size / chunkSize);
    let start = 0;

    for (let i = 0; i < chunks; i++) {
      const end = Math.min(start + chunkSize, fileObj.size);
      const chunk = fileBlob.slice(start, end);

      await msGraphPut(
        uploadUrl,
        chunk,
        false,
        {
          "Content-Range": `bytes ${start}-${end - 1}/${fileObj.size}`,
        },
        1
      );

      start = end;
    }

    return { success: true, data: sessionResponse };
  }
}

/** */
export async function uploadBlobFileToDest(
  fileBlob = null,
  file_name,
  drive_id,
  folder_id
) {
  if (!fileBlob) {
    throw new Error("Invalid file object");
  }

  const pth = `/drives/${drive_id}/items/${folder_id}:/${file_name}`;
  const uploadPath = `${pth}:/content?@microsoft.graph.conflictBehavior=rename`;

  const headers = {
    "Content-Type": fileBlob.type,
    "Content-Length": fileBlob.size,
  };

  console.log("Uploading file to:", uploadPath);

  if (fileBlob.size < 4 * 1024 * 1024) {
    // Upload small files directly
    console.log("tu je",fileBlob)
    return await msGraphPut(uploadPath, fileBlob, true, headers, 1);
  } else {
    // Upload large files using session
    const sessionPath = `${pth}:/createUploadSession?@microsoft.graph.conflictBehavior=rename`;
    const sessionResponse = await msGraphPost(sessionPath, null, true, {}, 1);
    const uploadUrl = sessionResponse.uploadUrl;

    const chunkSize = 5 * 1024 * 1024; // 5MB
    const chunks = Math.ceil(fileBlob.size / chunkSize);
    let start = 0;

    for (let i = 0; i < chunks; i++) {
        const end = Math.min(start + chunkSize, fileBlob.size);

        const chunk = fileBlob.slice(start, end);
  
        await axios.put(uploadUrl, chunk, {
          headers: {
            "Content-Range": `bytes ${start}-${end - 1}/${fileBlob.size}`,
          },
        });
  
        start = end;
        
    }
    return { success: true, data: sessionResponse };


  }
}

